import {TeamReport} from "@irati/types"

const buildTeamNames = (acc, current) => {
  return {
    ...acc,
    teamNames: [...acc.teamNames, current.teamName]
  }
}

const setValueWithinMinMaxRange = (mean: number, min: number, max: number) => {
  if (mean > max) {
    return max
  }
  if (mean < min) {
    return min
  }
  return mean
}

export const groupCloseTeams = (
  reports: TeamReport[],
  activeMin: number,
  activeMax: number,
  activeDifference: number,
  overallMin: number,
  overallMax: number,
  overallDifference: number) => {
  return reports.map((report) => {
    const engaged = setValueWithinMinMaxRange(report.engaged, activeMin, activeMax)
    const overall = setValueWithinMinMaxRange(report.overall, overallMin, overallMax)
    const updatedReport = {...report, engaged, overall}
    return updatedReport
  }).reduce((acc, current) => {
    const doesTeamAlreadyExist = acc.find((value) => {
      if (Array.isArray(value)) {
        return value.find((team) => team.teamName === current.teamName)
      }
    })
    if (doesTeamAlreadyExist) {
      return acc
    }

    const closeTeams = reports.filter((currentReport) => {
      return current.teamName !== currentReport.teamName
        && Math.abs(current.overall - currentReport.overall) <= overallDifference
        && Math.abs(current.engaged - currentReport.engaged) <= activeDifference
    })
    const updatedCurrent = closeTeams.length ? [current, ...closeTeams] : current

    return [...acc, updatedCurrent]
  }, []).reduce((acc, current) => {
    if (Array.isArray(current)) {
      const activeMean = current.reduce((num, val) => num + val.engaged, 0) / current.length
      const overallMean = current.reduce((num, val) => num + val.overall, 0) / current.length
      const adjustedActiveMean = setValueWithinMinMaxRange(activeMean, activeMin, activeMax)
      const adjustedOverallMean = setValueWithinMinMaxRange(overallMean, overallMin, overallMax)

      return [...acc, current.reduce(buildTeamNames, {teamNames: [], engaged: adjustedActiveMean, overall: adjustedOverallMean})]
    }
    const adjustedActiveMean = setValueWithinMinMaxRange(current.engaged, activeMin, activeMax)
    const adjustedOverallMean = setValueWithinMinMaxRange(current.overall, overallMin, overallMax)
    const adjustedCurrent = {...current, active: adjustedActiveMean, overall: adjustedOverallMean}
    return [...acc, adjustedCurrent]
  }, [])
}
